import { IconArrowLeft } from '@iwoca/icons';

export const NothingSelectedView = () => {
  return (
    <div className="flex min-h-[300px] items-center justify-center rounded-s">
      <div className="flex flex-col items-center gap-l text-center text-structure-40">
        <IconArrowLeft className="fill-current h-[40px] w-[40px]" />
        <h3 className="m-0 text-l font-bold text-structure-40">
          Select a plan from the list for details
        </h3>
      </div>
    </div>
  );
};
